import React from 'react';
import { getMetaDescription } from '@/utils/getMetaDescription';
import { checkForWrongDomain } from '@/utils/checkForWrongDomain';
import Layout from '@/components/Layout';
import Categories from '@/containers/Categories';
import { getSSRStoreData } from '../../utils/ssrPageData';
import { useSetSSRStore, useSSRSelector } from '../../redux';
import { getRequiredCtxProps } from 'src/utils/getRequiredCtxProps';

const CategoriesPage = (props) => {
  useSetSSRStore(props.ssrStore);
  const storeInfo = useSSRSelector((state) => state.storeReducer.store);
  return (
    <Layout
      store={storeInfo}
      title={`${storeInfo?.store_info?.name}${
        storeInfo?.address?.visibility === 1 && storeInfo?.address?.city
          ? `, ${storeInfo.address?.city}`
          : ''
      } - Order Online`}
      Icon={storeInfo?.store_info?.logo_image}
      metaDescription={storeInfo && getMetaDescription(storeInfo)}
      OGImage={storeInfo?.store_info?.logo_image}
      isCustomDomain={props.isCustomDomain}
      {...props}
    >
      <Categories {...props} />
    </Layout>
  );
};

export async function getServerSideProps(ctx) {
  if (checkForWrongDomain(ctx)) return {};

  let propData = {
    catalogCategories: [],
    catalogTags: [],
    collections: [],
  };

  const propType = await getSSRStoreData(ctx, {
    additionalDataToFetch: ['categories'],
  });

  propData = { ...propData, ...propType };
  const extraProps = getRequiredCtxProps(ctx, propType);

  return { props: { ...propData, ...extraProps } };
}

export default CategoriesPage;
